import React, {useState} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

export const ModalesMiPerfil = (props) => {
	const {
		modalBorrrarCuenta,
		setModalBorrrarCuenta,
		modalGuardarCambios,
		setModalGuardarCambios,
		Usuario,
		setUsuario,
		guardarCambios,
		eliminarPerfil,
	} = props;

	return (
		<>
			<Modal
				centered={true}
				isOpen={modalBorrrarCuenta}
			>
				<ModalHeader>
					<div className='titulo-modal'>Borrar Cuenta</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						¿Esta seguro de que desea eliminar esta cuenta?
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='button'
							onClick={() => setModalBorrrarCuenta(false)}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button borrarCuenta'
							onClick={() => eliminarPerfil()}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
			<Modal
				centered={true}
				isOpen={modalGuardarCambios}
			>
				<ModalHeader>
					<div className='titulo-modal'>Guardar</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>Guardar Cambios</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='button'
							onClick={() => setModalGuardarCambios(false)}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='buttonB'
							onClick={() => guardarCambios()}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
